import React from 'react'

import { SLToggle } from './SLToggle'
import { useManager } from '@/hooks'
import { setDiscoveryModeForRecording } from '@/actions/aloader'
import { useState } from 'react'

export function DiscoveryModeToggle({
  recording,
  onToggled = () => {}
}) {
  const manager = useManager()

  const active = recording?.discovery_mode?.select_for_campaign

  console.log("#recording", recording)

  const [error, setError] = useState(null)

  const [toggling, setToggling] = useState(false)

  const handleClick = (event) => {
    setToggling(true)
    setError(null)
    setDiscoveryModeForRecording({
      recordingId: recording.id,
      managerType: manager?.type,
      managerSlug: manager?.slug,
      active: !active
    }).then(() => {
      setToggling(false)
      setError(null)
      onToggled(!active)
    }).catch(e => {
      console.error(e)
      setToggling(false)
      setError(e)
    })
  }

  return (
    <SLToggle loading={toggling} checked={active} onClick={handleClick} />
  )
}